/* pdp-content.js: ported from zum-impulse, Alpine components registered on alpine:init */
document.addEventListener('alpine:init', function () {
  'use strict';

  /* Fabric video tabs (sections/fabric-video-tabs).
     Thumb buttons carry data-index / data-name / data-headline / data-body; the stage
     videos (x-ref="stage") are matched by position. Every video starts playing once it
     comes near the viewport (impulse custom.js section 15). */
  Alpine.data('fabricTabs', function () {
    var io = null;
    return {
      active: 0,
      name: '',
      headline: '',
      body: '',
      init: function () {
        var first = this.$root.querySelector('[data-fabric-thumb]');
        if (first) this.set(first);
        var videos = this.$root.querySelectorAll('video');
        var play = function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
        if (!('IntersectionObserver' in window)) {
          videos.forEach(play);
          return;
        }
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            play(e.target);
            io.unobserve(e.target);
          });
        }, { rootMargin: '200px' });
        videos.forEach(function (v) { io.observe(v); });
      },
      destroy: function () {
        if (io) io.disconnect();
      },
      set: function (btn) {
        this.active = parseInt(btn.getAttribute('data-index'), 10) || 0;
        this.name = btn.getAttribute('data-name') || '';
        this.headline = btn.getAttribute('data-headline') || '';
        this.body = btn.getAttribute('data-body') || '';
      },
      select: function (btn) {
        this.set(btn);
        var slide = this.$refs.stage && this.$refs.stage.querySelectorAll('video')[this.active];
        if (slide) {
          var p = slide.play();
          if (p && p.catch) p.catch(function () {});
        }
      }
    };
  });
});
